<template>
  <div
    class="formkit-inner formkit-disabled:bg-black-100 formkit-disabled:dark:bg-primary-1000 formkit-disabled:cursor-not-allowed formkit-disabled:pointer-events-none flex items-center ring-1 bg-white dark:bg-primary-1000 ring-black/20 dark:ring-white/20 focus-within:ring-primary focus-within:ring-2 [&>label:first-child]:focus-within:text-primary rounded mb-1"
  >
    <input
      ref="inputRef"
      type="text"
      class="formkit-input appearance-none bg-transparent dark:text-black rounded autoFillInputLightModeOverride dark:autoFillInputDarkModeOverride focus:outline-none focus:ring-0 focus:shadow-none w-full px-3 py-3 border-none text-base text-black-700 dark:text-white placeholder-black-300"
      :placeholder="context.placeholder ?? 'Введите сумму'"
    />
  </div>
</template>

<script setup>
import { watchDebounced } from '@vueuse/core'
import { ref } from 'vue'
import { useCurrencyInput } from 'vue-currency-input'

const emits = defineEmits(['update:modelValue'])

const props = defineProps({
  context: {
    type: Object,
  },
  modelValue: {
    type: [String, Number],
  },
})

const options = ref({
  currency: 'RUB',
  hideCurrencySymbolOnFocus: false,
  hideGroupingSeparatorOnFocus: false,
  hideNegligibleDecimalDigitsOnFocus: false,
})

const { inputRef, numberValue, setValue } = useCurrencyInput(options.value)

watchDebounced(numberValue, (v) => emits('update:modelValue', v), {
  debounce: 300,
})
</script>
